import callApi from "../../utils/callApi";
import { takeEvery, call, put, all, fork } from "redux-saga/effects";
import * as actions from "./actions";

function* handleGetAboutDataCounts(action: any): any {
    try {
        const res = yield call(callApi, 'get', process.env.REACT_APP_SEARCH_API_URL || '', '/v1/about/datacounts');
        if (res) {
            if (res.error) {
                throw new Error(res.message);
            }

            yield put(actions.aboutDataCountsSuccess(res));
        }
    } catch (error) {
        console.error(error);
        yield put(actions.aboutDataCountsError(error.message));
    }
}

function* watchAboutDataCounts() {
    yield takeEvery(actions.AboutActionTypes.GET_DATA_COUNTS, handleGetAboutDataCounts);
}

function* aboutSaga() {
    yield all([fork(watchAboutDataCounts)]);
}

export default aboutSaga;